import React from 'react';
import './ProfilSkeleton.css';

interface ProfilSkeletonProps {
  /** Affiche un bandeau d'en-tete (titre + pastille) au-dessus. */
  header?: boolean;
  /** Affiche une barre d'onglets factice au-dessus du contenu. */
  tabs?: boolean;
  /** Nombre de sections de contenu (bandeau gris + grille de champs). */
  sections?: number;
}

/**
 * Skeleton generique du profil (et de ses onglets) : bandeaux de section + grille
 * de champs, avec balayage shimmer. Utilise pendant le chargement, a la place des
 * textes "Chargement...".
 */
const ProfilSkeleton: React.FC<ProfilSkeletonProps> = ({ header = false, tabs = false, sections = 2 }) => (
  <div className="profil-skeleton" aria-hidden="true" aria-busy="true">
    {header && (
      <div className="profil-skel-topbar">
        <span className="pskel pskel-title" />
        <span className="pskel pskel-pill" />
      </div>
    )}
    {tabs && (
      <div className="profil-skel-tabs">
        {Array.from({ length: 5 }).map((_, i) => (
          <span className="pskel pskel-tab" key={i} />
        ))}
      </div>
    )}
    {Array.from({ length: sections }).map((_, s) => (
      <div className="profil-skel-section" key={s}>
        <div className="profil-skel-section-header" />
        <div className="profil-skel-grid">
          {Array.from({ length: 4 }).map((_, i) => (
            <div className="profil-skel-field" key={i}>
              <span className="pskel pskel-label" />
              <span className="pskel pskel-input" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default ProfilSkeleton;
